import { TranslateService } from '@ngx-translate/core';
import { SelectOptionI } from '../modules/configurable-form/components/form-multiselect/models/select-option-i';
import { COUNTRY_CODE, ReferenceDocuments, RmsContractBalance } from '@cemex-core/cmx-api';
import { UNITS } from '../constants/units';
import { _safe } from './safe-get.method';

export function rmsLoadAvailableContracts(
  contracts: ReferenceDocuments[],
  contractsBalance: { [contractCode: string]: RmsContractBalance[] },
  translate: TranslateService,
  withBalanceOnly = true,
  country: string,
): SelectOptionI[] {
  if (withBalanceOnly) {
    // Filter out contracts without balance that are supposed to have

    contracts = contracts.filter(contract => {
      const agreement = contractsBalance[contract.documentCode.replace(/^0+/, '')];
      if (
        _safe(() => agreement[0].agreementItems[0].hasBalance) &&
        _safe(() => agreement[0]['agreementType'].trim() !== 'Quotation')
      ) {
        return !!contractsBalance[contract.documentCode.replace(/^0+/, '')];
      } else if (_safe(() => agreement[0]['agreementType'].trim() === 'Quotation')) {
        return !!contractsBalance[contract.documentCode.replace(/^0+/, '')];
      } else {
        return false;
      }
    });
  }

  // Return select options
  return contracts.map(salesDocument => {
    return {
      id: salesDocument.documentCode.replace(/^0+/, ''),
      name: description(salesDocument, contractsBalance, translate, country),
    };
  });
}

function description(
  salesDocument: ReferenceDocuments,
  contractsBalance: { [contractCode: string]: RmsContractBalance[] },
  translate: TranslateService,
  country: string,
): string {
  const name = `${translate.instant('views.specifications.contract')} ${salesDocument.documentCode}`;
  const remainingVolume = contractsBalance[salesDocument.documentCode.replace(/^0+/, '')];
  if (_safe(() => remainingVolume[0].agreementItems[0].quantity)) {
    return `${name}  ‏‏‎  ‏‏‎  ‏‏‎  ${translate.instant('views.specifications.remaining_volume')}
    ${remainingVolume[0].agreementItems[0].quantity} ${
      country === COUNTRY_CODE.USA ? UNITS.CUBIC_YARD : UNITS.CUBIC_METERS
    }`;
  } else {
    return name;
  }
}
